import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { API } from "aws-amplify";
import IconDowload from "../../Resources/svg/Icons/IconDowload";
import IconTableDown from "../../Resources/svg/Icons/IconTableDown";
import Button from "./Button";
import Flags from "./Flags";

import {
  addClient,
  addHealthStatement,
  addWorkData,
  addBeneficiary,
} from "../../Store/simulate/actions";
import { decryptEstandar } from "../../Utils/CryptographyUtils";
import { formatNumber, handleState } from "../../Utils/utils";
import { generatePdfSimulateAS } from "../../Services/GeneratePdfSimulateAS";
import { getTitleCase } from "../../Utils/simulaciones/simulaciones";
import Loading from "../loading";
import Tooltips from "./Tooltips";
import IconOptions from "../../Resources/svg/Icons/IconOptions";
import IconCloseOptions from "../../Resources/svg/Icons/IconCloseOptions";

interface Props {
  data: any;
  codProd: any;
  activeProduct: any;
  availableButtons: any;
  showActions: any;
  setOpenModalAlertSendEmail: any;
  handleReviewSimulation: any;
}

const CardTablaRG = ({ data, codProd, activeProduct, availableButtons, showActions, setOpenModalAlertSendEmail, handleReviewSimulation }: Props) => {
  const [collapse, setCollapse] = useState(false);
  const [showoptions, setShowOptions] = useState(false);
  const [isLoading, setIsLoading] = useState<any>(false);
  const [linkPdf, setLinkPdf] = useState("");
  const elem: any = useRef(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const asesor = useSelector((state: any) =>
    decryptEstandar(state.login.username)
  );
  const capabilities = useSelector((state: any) => state.login.access_configuration.capabilities);

  const {
    estado,
    descripcionEstado,
    numSimulacion,
    fechaCreacion,
    datosCliente: { nombres, documento },
    datosSimulacion: {
      prima,
      tasa,
      vencimiento,
      moneda,
      primaBase,
      primaAhorro,
      sumaAsegurada,
    },
  } = data;

  const onClickCotizar = (item: any) => {
    let rutas: any = {
      IG: "/cotizaciones/datos-personales",
      AS: "/cotizaciones/datos-personales",
      UC: "/cotizaciones/datos-personales",
      RG: "/cotizaciones/datos-personales",
    };

    dispatch(addClient(item));

    history.push(rutas[item.producto.codigo]);

    window.digitalData.push({
      action: {
        group: "Simulaciones",
        category: "Listado",
        name: activeProduct,
        label: "Cotizar",
      },
      event: "trackAction",
    });
  };

  const handleCardStateTable = () => {
    setCollapse((c) => !c);
  };

  const hanldeOpenMenu = () => {
    setShowOptions(true);
    document.body.style.overflow = "hidden";
  };

  const hanldeCloseMenuCard = () => {
    setShowOptions(false);
    document.body.style.overflow = "auto";
  };

  const generatePdfSimulate = async (data: any) => {
    setIsLoading(true);
    if (data.producto.codigo == "IG" || data.producto.codigo == "UC") {
      const response = await API.get(
        "api-rentas",
        "/generate-pdf/" + data.idSimulacion,
        data.idSimulacions
      );

      if (response.status) {
        setLinkPdf(response.data);
      }

      setIsLoading(false);
    } else if (data.producto.codigo == "AS") {
      setIsLoading(false);
      return generatePdfSimulateAS(data);
    }
  };

  useEffect(() => {
    if (linkPdf) {
      elem.current.click();
    }
  }, [linkPdf]);

  return (
    <div className="card-table">
      <a
        style={{ display: "none" }}
        target="_blank"
        rel="noopener noreferrer"
        href={linkPdf}
        ref={elem}
      />
      <div className="flag-state-info">
        <Flags variant={estado}>{handleState(estado)}</Flags>
        {descripcionEstado && <Tooltips text={descripcionEstado} />}
      </div>
      <div className={`card-table__icon`} onClick={hanldeOpenMenu}>
        <IconOptions />
      </div>
      <div className="card-table__box">
        <div className="card-table__description">Nº de simulación:</div>
        <div className="card-table__data">{numSimulacion}</div>
        <div className="card-table__description">Fecha:</div>
        <div className="card-table__data">{fechaCreacion}</div>
        <div className="card-table__description">Contratante:</div>
        <div className="card-table__data">{getTitleCase(nombres)}</div>
        {collapse && (
          <>
            <div className="card-table__description">DNI/CE:</div>
            <div className="card-table__data">{documento}</div>
            <div className="card-table__description">Prima comercial:</div>
            <div className="card-table__data">
              {moneda && moneda.simbolo} {formatNumber.new(prima)}
            </div>
            <div className="card-table__description">Tasa:</div>
            <div className="card-table__data">{tasa}%</div>

            <div className="card-table__description">Vencimiento:</div>
            <div className="card-table__data">{vencimiento}</div>
          </>
        )}
        <div className="card-table__options" onClick={handleCardStateTable}>
          {collapse ? "Mostrar menos" : "Mostrar más"}
          <IconTableDown className={`${collapse ? "up" : "down"}`} />
        </div>

      </div>
      <div className="menu">
      <div className={`menu__box ${showoptions ? "open-options" : ""}`}>
        <div className="header-card">
          <div className="header-card__title">
            Más opciones{" "}
            <span onClick={hanldeCloseMenuCard}>
              <IconCloseOptions />
            </span>
          </div>
        </div>
        <div className="menu__options">
         {availableButtons(data) && (
          <>
            {!showActions(data).quote && (
              <div className="menu__buttons" onClick={() => onClickCotizar(data)}>
                <div>Cotizar</div>
              </div>
            )}
            {!showActions(data).improve && capabilities.canEditRatesRG && (
              <div className="menu__buttons" onClick={() => handleReviewSimulation(data)}>
                <div>Mejorar</div>
              </div>
            )}
            {!showActions(data).pdf && (
              <div className="menu__buttons" onClick={() => generatePdfSimulate({ ...data, asesor })}>
                <div>Descargar</div>
              </div>
            )}
            {!showActions(data).send && (
              <div className="menu__buttons" onClick={() => setOpenModalAlertSendEmail(true)}>
                <div>Enviar correo</div>
              </div>
            )}

          </>
         )}
        </div>
      </div>
      <div
          className={`menu__background ${showoptions ? "open-options" : ""}`}
        ></div>
      </div>
      {isLoading && <Loading />}
    </div>
  );
};

export default CardTablaRG;
